import { ApplicationRole } from "../../../../api";

export const ROLE_LABELS: Record<string, string> = {
  [ApplicationRole.ADMIN]: "Admin",
  [ApplicationRole.ATTORNEY]: "Attorney",
  [ApplicationRole.STAFF]: "Staff",
  [ApplicationRole.STAFF_ATTORNEY]: "Staff Attorney",
  [ApplicationRole.USER]: "User",
  [ApplicationRole.REFFERAL_STAFF]: "Referral Staff",
  [ApplicationRole.CLIO_STAFF]: "Clio Staff",
  [ApplicationRole.CLIO_ADMIN]: "Clio Admin",
  [ApplicationRole.CLIO_MANAGER]: "Clio Manager",
  [ApplicationRole.CLIO_TASK_ASSIGNER]: "Clio Task Assigner",
  [ApplicationRole.QA]: "QA",
};

export function formatRole(role: ApplicationRole | string) {
  return ROLE_LABELS[role] ?? role;
}
